import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import RankingSection from './components/RankingSection';
import LatestSection from './components/LatestSection';
import RecommendSection from './components/RecommendSection';
import WeeklyHot from './components/WeeklyHot';

export default function Home() {
  return (
    <>
      <HeroSection />
      <main>
        <CategoryNav />
        <RankingSection />
        <LatestSection />
        <RecommendSection />
        <WeeklyHot />
      </main>

      {/* WebPage Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '蜜桃少年漫画 - 漫画全集免费阅读下拉式 - 土豪漫画网',
          description: '蜜桃少年漫画，在土豪漫画网漫画全集免费阅读下拉式体验蜜桃少年，在线下拉浏览完整故事，享受免费且流畅的阅读乐趣。',
          url: 'https://mitaoshaonian.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '蜜桃少年漫画',
            url: 'https://mitaoshaonian.com/',
          },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://mitaoshaonian.com/' },
            ],
          },
        })}
      </script>
    </>
  );
}